import { InputData } from "../input/InputData";

export class APIInputData extends InputData
{
  api:string;
}